<template>
  <div class="list-general-wrap">
    <div class=" mb-2" v-if="listObj.title">
      <h2
          v-if="config.is_title"
          class="fw-bolder text-secondary">
        {{listObj.title}}
      </h2>


      <template
        v-if="listObj.micro_dashboard"
      >
        <display-debug>
          <template #debugView>
            listObj.micro_dashboard: {{listObj.micro_dashboard}}
          </template>
        </display-debug>

      </template>

      <div
          v-if="btnObj"
          class=""
      >
        <router-link
            v-if="config.is_btn_prefill"
            v-for="(btnItem, btnIndex)  in btnObj"
            :to="btnItem.path"
            class="btn btn-warning me-2 mb-2 fw-medium"
        >
          <i v-if="btnItem.ico" :class="btnItem.ico + '  me-1'"></i>
          <span v-if="btnItem.title">{{btnItem.title}}</span>
        </router-link>

        <button
            type="button"
            @click="reloadData"
            class="btn btn-warning fw-medium mb-2"
            :title="$t('list_general.header.refresh_hint')"
        >
          <i class="bi bi-arrow-repeat me-1"></i>
          <span>{{ $t('list_general.header.refresh_title') }}</span>
        </button>
      </div>
    </div>

    <list-filter
      v-if="filters && is_filter && config.is_filter"
      :filter-data="filters"
      :ident="ident"
      v-model:reloadFilter="dataFilter"
    />

    <div
        v-if="listObj.pocet > 0"
        class="container-fluid table-responsive"
    >
      <!-- -->
      <list-paging
          type="no-swiper"
          :paging-data="listObj.paging"
      />

      <table
          class="table table-hover align-middle w-100"
      >
        <thead
            v-if="is_header && listObj.header && config.is_list_header"
            class="table-secondary"
            style="font-size: .85rem;"
        >
          <tr>
            <template
              v-for="(headerItem, headerIndex)  in listObj.header"
             >
              <td
                  v-if="headerIndex != '__actions'"
                  :class="((headerItem.data.class_head)? ' ' + headerItem.data.class_head: '')"
              >
                <span class="title" v-html="headerItem.data.title"/>
              </td>
            </template>

          </tr>
        </thead>

        <tbody>
        <tr
            v-for="(row, rowIndex)  in listObj.data"
            class="animated-list-row"
        >
          <!-- todo __actions -->
          <template
              v-for="(cell, cellIndex)  in row"
          >
            <td

                v-if="cellIndex != '__actions'"
                :class="'list-animation' + ((listObj.header[cellIndex].data.class)? ' ' + listObj.header[cellIndex].data.class: '')"
            >
              <!--
              <pre>{{listObj.header[cellIndex].data.type}}</pre>

              -->
            <span
                v-if="listObj.header[cellIndex].data.type == 'id'"
                class="text-sm-center"
            >
              <span>#{{cell}}</span>
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'text'"
                  class="text-sm-center"
              >
              {{cell}}
            </span>
              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'slug'"
                  class=""
              >
                <span class="cms5-display-slug" :title="cell">{{cell}}</span>
            </span>

              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'datum_cas'"
                  class="cell-date"
              >
              <span v-format-date:custom.time="cell"></span>

              <!--
              <dateime-preview
                  :value="cell"
                  :is_date="true"
                  :is_time="true"
              />
                -->
            </span>

              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'locked'"
                  class="cell-date"
              >
                <span
                  v-if="cell"
                >
                  <i class="bi bi-lock-fill fs-5 text-danger"></i>
                </span>
              </span>

              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'datum'"
                  class="cell-date"
              >
              <span v-format-date="cell"></span>

              </span>
              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'datetime'"
                  class="cell-date"
              >
                <template v-if="cell">
                <span
                    v-format-date="cell.date"
                ></span>
                </template>

            </span>

              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'cas'"
                  class="cell-date"
              >
              <span v-format-date:custom.time.timeOnly="cell"></span>
               <!--
              <dateime-preview
                  :value="cell"
                  :is_time="true"
              />
                -->
            </span>

            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'bool'"
                  class="cell-text"
              >
              <span
                v-marker-bool="cell"
                class="fs-5"
              ></span>

  <!--
              <i v-if="cell==1" class="bi bi-check-circle-fill text-success"></i>
              <i v-else class="bi bi-x-circle-fill text-danger"></i>
  -->
            </span>
              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'lock_bool'"
                  class="cell-text"
              >
                <i v-if="cell==1" class="bi bi-lock-fill text-danger"></i>

            </span>

              <span
                  v-else-if="listObj.header[cellIndex].data.type == 'bool_value_only'"
                  class="cell-text"
              >
                <i v-if="cell" class="bi bi-check-circle-fill text-success"></i>
            </span>

            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'btn_edit'"
                  class="cell-btn"
              >
              <router-link
                  v-if="cell"
                  :to="cell"
                  class="btn btn-primary"
              >
                <i class="bi bi-pen"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </router-link>
              <span
                v-else
                class="btn btn-secondary disabled"
              >
                Nelze editovat
              </span>
            </span>

            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'btn_view'"
                  class="cell-btn"
              >
              <router-link
                  :to="cell"
                  class="btn btn-primary"
              >
                <i class="bi bi-eye"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </router-link>
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'btn_clone'"
                  class="cell-btn"
              >
              <router-link
                  :to="cell"
                  class="btn btn-warning"
              >
                <i class="bi bi-boxes"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </router-link>
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'btn_stats'"
                  class=""
                  @click.prevent="statsItem(cell,listObj.header[cellIndex].data.module)"
              >
              <router-link
                  :to="cell"
                  class="btn btn-outline-primary"
              >
               <i class="bi bi-graph-up"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </router-link>
                <!--
                <pre>{{listObj.header[cellIndex].data}}</pre>
                -->
            </span>
            <span
                v-else-if="listObj.header[cellIndex].data.type == 'btn_delete'"
                class="btn btn-danger"
                @click.prevent="deleteItem(rowIndex, cell)"
            >
            <i class="bi bi-trash"></i>
            <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
          </span>
            <span
                v-else-if="listObj.header[cellIndex].data.type == 'btn_detail'"

            >
            <router-link
                :to="cell"
                class="btn btn-info"
            >
              <i class="bi bi-eye"></i>
              {{listObj.header[cellIndex].data.params.btn_title}}
            </router-link>
          </span>
            <span
                v-else-if="listObj.header[cellIndex].data.type == 'btn_custom'"
                class="cell-image"
            >
              <span
                  @click.prevent="customBtnFunction(cell, listObj.header[cellIndex].data.params, row)"
                  class="btn btn-outline-primary"
              >
                <i
                    v-if="listObj.header[cellIndex].data.params && listObj.header[cellIndex].data.params.ico"
                    :class="listObj.header[cellIndex].data.params.ico"
                ></i>
                {{listObj.header[cellIndex].data.params.btn_title}}
              </span>
            </span>

            <span
                v-else-if="listObj.header[cellIndex].data.type == 'btn_web_lang'"
                class="cell-btn"
            >
              <div
                v-if="cell"
              >

                <div
                    class="d-flex text-light bg-secondary rounded rounded-2 p-2 mb-2 mt-2"
                >
                  <div
                    class="ms-1"
                  >
                    <i class="bi bi-globe opacity-75 me-1"/>
                  </div>

                  <template
                    v-for="(item, index) in cell"
                  >
                        <a
                            :href="item.path"
                            :title="item.path"
                            target="_blank"
                            class="col text-center text-light text-decoration-none"
                        >
                          <span
                            class="d-none d-md-inline"
                          >
                            <country-flag
                                :country='item.flag'
                                size="small"
                            />
                            {{item.title}}
                          </span>
                          <span
                              class="d-md-none ms-1"
                          >
                            <country-flag
                                :country='item.flag'
                                size="small"
                            />
                          </span>



                        </a>
                      </template>
                </div>

                <div
                    v-if="1==0"
                  class="text-light bg-secondary rounded rounded-2 p-1 mb-2"
                >
                  <div
                    class="text-center"
                  >
                    <i class="bi bi-globe opacity-75 me-1"/>
                  </div>
                  <div
                    class="container"
                  >
                    <div
                        class="row"
                    >
                      <template
                          v-for="(item, index) in cell"

                      >
                        <a
                            :href="item.path"
                            :title="item.path"
                            target="_blank"
                            class="col text-center link-light"
                        >

                          <span>{{item.title}}</span>
                        </a>
                      </template>
                    </div>
                  </div>


                </div>


                <template
                    v-if="1==0"
                  v-for="(item, index) in cell"

                >
                    <a
                      :href="item.path"
                      :title="item.path"
                      target="_blank"
                      class="btn btn-sm btn-secondary me-1 mb-1 flex-nowrap"
                    >
                      <i class="bi bi-globe opacity-75 me-1"/><span>{{item.title}}</span>
                    </a>
                </template>
              </div>
            </span>

            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'btn_web'"
                  class="cell-btn"
              >
<!-- -->


               <router-link
                   v-if="cell"
                   :to="cell"
                   target="_blank"
                   class="btn btn-info"
               >
                <i class="bi bi-globe"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </router-link>


            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'btn_download'"
                  class="cell-btn"
            >
              <div
                  class="btn btn-secondary"
                  @click.prevent="btnDownload(cell)"
              >
                  <i class="bi bi-download"></i>
                  <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </div>

              <!--
               <router-link
                   v-if="cell"
                   :to="cell"
                   target="_blank"
                   class="btn btn-secondary"
               >
                <i class="bi bi-download"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </router-link>
-->
            </span>
            <span
                v-else-if="listObj.header[cellIndex].data.type == 'btn_context_menu'"
                class="cell-btn"
            >
              <template
                v-if="cell.status"
              >
              <a
                  href="#context"
                  @click.prevent="openContextMenu($event, cell.menu)"
                  class="bi bi-three-dots-vertical link-secondary"
              />
              </template>
            </span>

            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'price_currency'"
                  class="cell-btn"
            >
              <template
                v-if="JSON.parse(cell).prefixed"
              >
                {{ JSON.parse(cell).currency_title }}&nbsp;
              </template>{{ JSON.parse(cell).price }}<template
                  v-if="!JSON.parse(cell).prefixed"
              >
                &nbsp;{{ JSON.parse(cell).currency_title }}
              </template>

            </span>

            <span
                v-else-if="listObj.header[cellIndex].data.type == 'title_ico_class_object'"
                class="cell-btn"
            >
              <span
                  v-if="cell"
                  :class="'cell-wrap ' + cell.class"
              >
                <i
                  v-if="cell.ico"
                  :class="cell.ico+ ' me-1'"
                ></i>
                <span
                    v-if="cell.title"
                >
                  {{cell.title}}
                </span>
              </span>
            </span>

            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'invoice_due'"
                  class="cell-btn"
            >
              <span
                  v-if="cell.is_paid"
                  class="text-success"

              >
                <i class="bi bi-check-circle"></i>
                {{$t('invoice.list.due_item.paid')}}
              </span>

              <template v-else>

                <span
                    v-if="cell.is_due"
                    class="text-danger"
                >
                  <i class="bi bi-exclamation-triangle-fill"></i>
                  {{$t('invoice.list.due_item.is_due',cell.days_diff, {count: cell.days_diff})}}
                </span>
                 <span
                     v-else
                     class="text-primary"
                 >
                   <i class="bi bi-hourglass-split me-1"></i>
                   {{ $t('invoice.list.due_item.due_waiting', cell.days_diff, {count: cell.days_diff}) }}
                </span>
              </template>
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'image_preview'"
                  class="cell-image"
              >
              <image-component
                  v-if="cell"
                  :is_preview_only="true"
                  :image-id="cell"
                  thumb_class="list"
              />
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'user_preview'"
                  class="cell-image"
              >
              <user-preview
                  v-if="cell"
                  :user-id="cell"
              />
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'minuta2hodina'"
                  class="cell-image"
              >
                <span>{{(cell/60).toFixed(1)}}</span>
            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'open_web'"
                  class="cell-btn"
              >
              <a
                  v-if="cell"
                  :href="cell"
                  target="_blank"
                  class="btn btn-info text-white"
              >
                <i class="bi bi-globe"></i>
                <span class="d-none d-md-inline ms-2">{{listObj.header[cellIndex].data.params.btn_title}}</span>
              </a>
              <span
                  v-else
                  class="btn btn-secondary disabled"
              >
                Neni
              </span>


            </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'price_json'"
                  class="cell-btn"
              >
                <div
                  v-if="cell.is_sale"
                >
                  <i class="bi bi-coin me-2"/>
                  <span>{{ formatPrice(cell.price_sale, cell.currency_title)}}</span>
                  <span class="text-decoration-line-through ms-1">{{ formatPrice(cell.price, cell.currency_title)}}</span>

                </div>
                <div
                  v-else
                >
                  <span>{{formatPrice(cell.price, cell.currency_title)}}</span>
                </div>
             </span>
            <span
                  v-else-if="listObj.header[cellIndex].data.type == 'tags_array'"
                  class="cell-btn"
            >
              <template
                v-for="(tag, tIndex) in cell"
              >
                <span
                  class="btn btn-sm btn-outline-secondary me-1 mb-1"
                >
                  {{tag}}
                </span>
              </template>
            </span>
            <span
                v-else-if="listObj.header[cellIndex].data.type == 'range_object'"
                class="cell-btn"
            >
              <span
                class="d-block"
              >
                {{calculateTimeDifference('cs', cell.from, cell.to).date}}
              </span>
             <span
                 v-if="calculateTimeDifference('cs', cell.from, cell.to).time"
                 class="d-block text-muted"
             >
               {{calculateTimeDifference('cs', cell.from, cell.to).time}}
             </span>

              <small class="range-wrap text-muted">
                <span
                  v-if="calculateTimeDifference('cs', cell.from, cell.to).range.days"
                >
                  {{calculateTimeDifference('cs', cell.from, cell.to).range.days}}
                  {{ $t('list_general.items.range.day', calculateTimeDifference('cs', cell.from, cell.to).range.days) }}
                </span>
                <span
                    v-if="calculateTimeDifference('cs', cell.from, cell.to).range.hours"
                    class="ms-1"
                >
                  {{calculateTimeDifference('cs', cell.from, cell.to).range.hours}}
                  {{ $t('list_general.items.range.hour', calculateTimeDifference('cs', cell.from, cell.to).range.hours) }}
                </span>
                <span
                    v-if="calculateTimeDifference('cs', cell.from, cell.to).range.minutes"
                    class="ms-1"
                >
                  {{calculateTimeDifference('cs', cell.from, cell.to).range.minutes}}&nbsp;
                  {{ $t('list_general.items.range.minute', calculateTimeDifference('cs', cell.from, cell.to).range.minutes) }}
                </span>
              </small>


<!--
              <pre>  {{calculateTimeDifference('cs', cell.from, cell.to).range }}</pre>
-->
            </span>
              <span
                  v-else
                  class="col-non-defined"
              >
              [NOT][{{listObj.header[cellIndex].data.type}}] {{cell}}
            </span>

            </td>
          </template>


        </tr>
        </tbody>

      </table>
      <!--
      <list-paging
        :paging-data="listObj.paging"
      />
      -->
    </div>

    <div v-else class="d-flex align-items-center justify-content-center w-100 vh-50">
      <div class="bg-danger text-white rounded-2 px-2 py-1">
        <div class="text-center">
          <i class="bi bi-eye-slash"></i>
        </div>
        <div>
          Žádné výsledky
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { gsap, Back, Power1 } from "gsap"
import ImagePreview from "@/components/general/ImagePreview";
import UserPreview from "@/components/previews/UserPreview";
import CountryFlag from "vue-country-flag-next"
import ImageComponent from "@/components/general/Image";
import 'vue3-treeselect/dist/vue3-treeselect.css'
import Treeselect from 'vue3-treeselect'
import Multiselect from 'vue-multiselect'
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import ListFilter from"@/components/general/list/ListFilter"
import ListPaging from"@/components/general/list/ListPaging"
import {calculateTimeDifference} from "@/utils/api";
import ContextMenu from '@imengyu/vue3-context-menu';
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css';
let swiperInstance;
export default {
  name: "ListGeneral",
  components: {
    gsap,
    Back,
    Power1,
    axios,
    ImagePreview,
    UserPreview,
    ImageComponent,
    //DateimePreview,
    Treeselect,
    Multiselect,
    Swiper,
    SwiperSlide,
    ListFilter,
    ListPaging,
    CountryFlag,
  },
  props: {
    "ident": String,
    "returnData": [Object, String, Number],
    "listObj": Object,
    "btnObj": Object,
    "modulName": String,
    "reloadSignal": String,
    "filters": [Object, Array],
    "is_animation": [Boolean],
    "is_filter": [Boolean],
    "is_header": [Boolean],
    "is_paging": [Boolean],
    "is_minimal": [Boolean],
    "config": [Object, Array],
  },
  setup() {
    /*
    const onSwiper = (swiper) => {
      swiperInstance = swiper;
    };
    return {
      onSwiper,
      modules: [Navigation, Pagination, Scrollbar],
    };
    */
  },
  emits:[
    'update:reloadSignal',
  ],
  data() {
    return {
      list: [],
      filterModel: {},
      isSetupFilters: false,
      cursor: null,

      dataFilter: null,
    }
  },
  methods: {
    handleListAction(action) {
      console.log('dev list handleAction', action)
      if(action.type == 'link') {
        this.$router.push(action.link);

      }else if(action.type == 'method') {
        if (typeof this[action.method] === 'function') {
          this[action.method](...Object.values(action.param));
        } else {
          console.warn(`Metoda ${action.method} na této komponentě neexistuje!`);
        }
      }
    },
    openContextMenu(event, definition) {
      event.preventDefault();

      definition = definition.map(item => {
        // Pokud jde o oddělovač, vrátíme ho bez úprav
        if (item.divided) {
          return { divided: true };
        }

        // Pro běžnou položku dynamicky vytvoříme objekt s funkcí onClick
        return {
          label: item.label,
          icon: item.icon,
          onClick: () => {
            this.handleListAction(item.action);
          }
        };
      });

      ContextMenu.showContextMenu({
        x: event.clientX,
        y: event.clientY,
        items: definition,
      });
    },
    calculateTimeDifference,
    async customBtnFunction(id, params, row) {
      if(params.is_confirm && params.confirm_message) {
        if(confirm(params.confirm_message)) {
          if(params.path){
            const postData = new FormData
            postData.append('id', id)
            postData.append('row', JSON.stringify(row))
            postData.append('params', JSON.stringify(params))

            axios.defaults.baseURL = this.getBaseRoot();
            await axios({
              url: params.path,
              method: "post",
              data: postData,
              withCredentials: true,
              headers: this.getRequestHeader(),
            }).then((res) => {
              if(res.data.response.is_row_delete) {
                console.log('dev delete row ')

              }else if(res.data.response.is_row_change) {
                for (const row_key in row) {
                  row[row_key] = res.data.response.row[row_key];
                }
              }
            });
          }else{
            console.error('Neni zadana cesta k methode')
          }
        }
      }else{
        //
      }


    },

    animateListLoading() {
      //console.log("list animateListLoading")
      if(this.is_animation) {
        gsap.from(".animated-list-row", {
          //y: 300,
          opacity: 0,
          duration: .05,
          stagger: 0.05,
        });
      }
    },
    reloadData(){
      this.$emit("update:reloadSignal", String(Math.random()));
    },

    async btnDownload(urlDownload) {
      let apiPath = '/class' + urlDownload
      //console.log('dev downloadu apiPath', apiPath)
      axios.defaults.baseURL = this.getBaseRoot();
      axios({
        url: apiPath,
        method: 'get',
        withCredentials: true,
        headers: this.getRequestHeader(),
        responseType: "blob",
      }).then((response) => {
        const parsedUrl = new URL(this.getBaseRoot() + apiPath);
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        //console.log('dev downloadu url', url)
        link.href = url;
        link.download = parsedUrl.searchParams.get("file"); // Název souboru
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        console.error("getVendorClients ERR", err);
      })
    },

    btnCall(method, index, item) {

      if(method == 'editItem') {
        const path = "/" + this.modulName + '/edit/' + item.id;
        //console.log("dev btnCall", method, path);
        this.$router.push(path);
      }else if(method == 'deleteItem') {
        const path = "/" + this.modulName + '/delete/' + item.id;
        const deleteText = "Opravdu chcete smazat zaznam #"+ item.id +"?"
        if (confirm(this.$t('list_general.action.delete_confirm')) == true) {
          //todo delete
          delete this.listObj.content[index];
        }
      }else{
        console.log("dev btnCall", method, index, item)
        console.log("dev this.$route.params", this.$route.params)
      }

    },

    deleteItem(row_index, item) {
      if (confirm(this.$t('list_general.action.delete_confirm')) == true) {
        axios({
          url: '/class' + item,
          method: "get",
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          if (res.data.status) {
            this.listObj.data.splice(row_index, 1);
          }else{
            alert("chyba mazani " + res.data.err.message)
          }
          console.log("dev deleteItem OK", res.data.err)

          //console.log("dev deleteItem OK row_index", this.listObj.data[row_index])

        }) .catch(function(err){
          //pseudothis.err = err;
          console.log("dev deleteItem  catch", err)
        })
        .finally((data) =>{
          console.log("dev deleteItem  finally", data)

        })

        console.log("dev editItem", item)
      }

    },
    formatPrice(price, currency = 'usd', decimalCount = 5) {
      const isWhole = Number.isInteger(price);
      return new Intl.NumberFormat(
          this.$t('system.locale_full'),
          {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: isWhole ? 0 : 1,
        maximumFractionDigits: decimalCount
      }).format(price)
    },

    getCellType(index){
      for (let i = 0; i < this.listObj.header.length; i++) {
        if(this.listObj.header[i].ident == index) {
            return this.listObj.header[i].type;
        }
      }
    },

    getList(){
      //const template = this.cfg.general.flash_messages.root_local_storage_name + "__";
      const template = this._getConfig('general.flash_messages.root_local_storage_name') + "__";


      for (var i = 0; i < localStorage.length; i++) {
        if(localStorage.key(i).startsWith(template) && localStorage.getItem(localStorage.key(i))) {
          //console.log('dev FlashMessage', localStorage.key(i), localStorage.getItem(localStorage.key(i))) ;
          this.list.push({
            type: localStorage.key(i).replace(template, ""),
            title: localStorage.getItem(localStorage.key(i))
          })
        }
        //TODO nacteni z API
        if(this.is_auto_delete == true) {
          for (var i = 0; i < localStorage.length; i++) {
            if(localStorage.key(i).startsWith(template)) {
              //console.log('dev FlashMessage cleare', localStorage.key(i) ) ;
              localStorage.setItem(localStorage.key(i), null);
            }
          }
        }

      }
    },

  },
  computed: {
    smartPaging(){
      if (typeof this.listObj.paging != "undefined") {
      let active = this.listObj.paging.list.filter(function(item){
        if(item.is_active == true){
          return item;
        }
      })
      const activeNumber = parseInt(active[0].number)
      if(!this.cursor) {
        this.cursor = activeNumber;
      }

      let smartPaging = {
        cursor: this.cursor,
        max: this.listObj.paging.page_count,
        offset: 5,
        from_item: 0,
        to_item: 0,
        list: [],
      }

      if(smartPaging.cursor >= smartPaging.max) {
        smartPaging.cursor = smartPaging.max;
        this.cursor = smartPaging.cursor
      }
      if(smartPaging.cursor <= 1) {
        //console.log('cursor 1', smartPaging.cursor)
        smartPaging.cursor = 1;
        this.cursor = smartPaging.cursor
      }
      if(this.listObj.paging.page_count > 2 * smartPaging.offset){
        if ((smartPaging.cursor  - smartPaging.offset) < 0) {
          smartPaging.from_item = 1;
          smartPaging.to_item = smartPaging.cursor + smartPaging.offset + Math.abs(activeNumber - smartPaging.offset);
        }else if((smartPaging.cursor + smartPaging.offset) > this.listObj.paging.page_count){
          smartPaging.to_item = this.listObj.paging.page_count;
          smartPaging.from_item = smartPaging.cursor - smartPaging.offset - Math.abs(this.listObj.paging.page_count - (smartPaging.cursor + smartPaging.offset));
        }else{
          smartPaging.from_item = smartPaging.cursor - smartPaging.offset;
          smartPaging.to_item = smartPaging.cursor + smartPaging.offset;
        }
      }else{
        smartPaging.from_item = 1;
        smartPaging.to_item = this.listObj.paging.page_count;
      }

      smartPaging.list = this.listObj.paging.list.filter((item) => {
        //console.log('list limit', smartPaging.cursor, smartPaging.from_item, smartPaging.to_item)
        if(item.number >= smartPaging.from_item && item.number <= smartPaging.to_item ){ // && item.number < smartPaging.to
          return item;
        }
      })

      return smartPaging;
      }
    },
  },
  mounted() {
    if(this.listObj.page && this.listObj.page > 1) {
      //swiperInstance.slideTo(this.listObj.page)
    }


    //filters value
    /**
    if(this.filters) {
      for (const key in this.filters) {
        if(this.filters[key].definition.type== 'checkboxes'){
          if(!this.filterModel[key]) this.filterModel[key] = [];
        }else{
          if(!this.filterModel[key]) this.filterModel[key] = null;
        }
      }

      if (JSON.parse(localStorage.getItem(this.ident +"_filter"))){
        const loadedFilters = JSON.parse(localStorage.getItem(this.ident +"_filter"))
        for (const fKey in loadedFilters) {
          if(loadedFilters[fKey]) {
            this.filterModel[fKey] = loadedFilters[fKey];
          }
        }
      }
    }
     */
    this.animateListLoading()
  },
  watch: {
    dataFilter: {
      handler(newval) {
        //this.$emit("update:reloadSignal", String(Math.random()));
        this.$emit("update:reloadSignal", newval);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>